
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {createbankstatements } from '../../api/bankstatements.api'

import './dashboardinicial.scss';






const Pdashboardinicial = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  
  
  

  if (!loftytoken) {
		return (<div>Requiere Autenticación</div>);
	}

  return (
    <div id="id65452847c239522da2e3aeed" >

      <div id="fgfg" className="">
      
      <div id="iifg" className="gjs-row ">
      
      <div id="ig49" className="gjs-cell ">
      
      <div id="i99szh" className="">
      
        <a
          target=""
          className=""
          id="i9ymbj"
          href={`/dashboard`}
        >
          
      <img
        className=""
        id="i1d1f1"
        src="https://assetsprojects.s3.amazonaws.com/405opfilkr0oo7y.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div id="iyxmw" className="">
      
        <a
          target=""
          className=""
          id="ishz2"
          href={`/dashboard`}
        >
          
      <div id="i0uip" className="itemnavigationdefault ">
      
      <div className="" id="ij9fr">
        <>Inicio</>
      </div>
      
      </div>
      
        <a
          target=""
          className=""
          id="isgtq"
          href={`/dashboard/productos`}
        >
          
      <div id="i51wa" className="itemnavigation ">
      
      <div className="" id="ib3yz">
        <>Mis Productos</>
      </div>
      
      </div>
      
        </a>
        
        </a>
        
        <a
          target=""
          className=""
          id="isg1w"
          href="#"
        >
          
      <div id="ihupb" className="itemnavigation ">
      
      <div className="" id="irvrr">
        <>Configuraciones</>
      </div>
      
      </div>
      
        </a>
        
      </div>
      
      <div id="igr3j" className="">
      
      <button
        type=""
        name=""
        id="i0k7v"
        className="buttoniniciosesion "
        onClick={async () => {
		deleteLoftytokenApp();
		window.location.href = '/signin';
}}

      >
      
      <div className="" id="isj6f">
        <><br />          Cerrar Sesion<br />        </>
      </div>
      
      </button>
      
      </div>
      
      </div>
      
      <div id="io5ng" className="gjs-cell ">
      
      <div id="ipm2s" className="">
      
      <div className="" id="if76p">
        <>Inicio</>
      </div>
      
      </div>
      
      <div id="i2c23" className="">
      
      <div id="iy6mf" className="">
      
      <div className="" id="it73y">
        <>¡Bienvenido! Estamos aquí para ayudarte a gestionar tu flujo de caja de manera eficiente. Si tienes alguna pregunta, no dudes en contactarnos. ¡Tu éxito financiero es nuestra prioridad!</>
      </div>
      
        <div className="" id="is8bw">
          
      <form
        id="imk9s"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
					for (const loftyFile of e.target.fileBucket.files) {
				createbankstatements({
							token: loftyuser?._id,
					usuario: loftyuser?._id,
				});
					}			alert("Se agrego de manera exitosa");
		} catch (error) {
					console.log(error);
				}
			}}
		
      >
        
      <div id="ibtkj" className="">
      
      <br className="" id="" />
      
      <div className="" id="i4coh">
        <>Sube tus extractos bancarios aquí y recibirás notificaciones por WhatsApp y correo sobre las novedades de tu cuenta.</>
      </div>
      
      <input
        name="fileBucket"
        type="file"
        placeholder=""
        className=""
        id="itedt"
      />
      
      </div>
      
      <button
        type="submit"
        name=""
        id="ir2ls"
        className="buttoniniciosesion "
        
      >
      
      <div id="iuups" className="">
      <>Enviar</>
      </div>
      
      </button>
      
      </form>
      
        </div>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pdashboardinicial);
  